<script>
    import { Card, CardBody, CardFooter, CardHeader, Pagination, PaginationItem, PaginationLink, Table, Button} from 'sveltestrap';
    import {downloadByteArray} from '../common/helpers/CSVHelper.js';
    import Search from '../components/Search.svelte';
    import TableColumn from '../components/TableColumn.svelte';
    import Tag from '../components/Tag.svelte';
    import http from '../api/http.js';
    import { selectedGroup} from '../store.js'; 
    import ForgetEndpointModal from "../modals/ForgetEndpointModal.svelte";
    import formatDate from '../Helpers/DateTimeFormatter'
    
    export let vesselId;
    export let byVessel;

    let searchTerm = "";
    let endpoints = [];
    let pageNumber = 1;
    let totalPageCount = 0;
    let totalEndpointCount = 0;
    let inputLength = 0;
    let searchRefresh = false;
    let previousPageNumber = 0;
    const displayNumbers = [10, 25, 50, 100, 200];
    let forgetEndpointModal;

    let displayNumber = displayNumbers[0];

    let sortType = {
        ascending: 'ascending',
        descending: 'descending',
        resting: 'resting'
        }

    let activeColumn = {
        columnValue: 0,
        sortType: sortType.ascending,
    };

    function toggleSort(columnValue, theSortType){
        if(activeColumn.value != columnValue){
        activeColumn.columnValue = columnValue;
        }
        switch(theSortType){
        case sortType.resting:
            activeColumn.sortType = sortType.ascending;
            break;
        case sortType.ascending:
            activeColumn.sortType = sortType.descending;
            break;
        case sortType.descending:
            activeColumn.sortType = sortType.ascending;
            break;
        }

        if(activeColumn.sortType != sortType.resting){
        loadEndpoints(columnValue, activeColumn.sortType);
        }
        else{
        activeColumn.columnValue = 0;
        activeColumn.sortType = sortType.ascending;
        loadEndpoints(0, activeColumn.sortType);
        }
    }

    $:activeColumn;

    $: {    
      if($selectedGroup != undefined){
        loadEndpoints(activeColumn.columnValue, activeColumn.sortType);
      }  
    }

    $: {    
      displayNumber;
      loadEndpoints(activeColumn.columnValue, activeColumn.sortType);
    } 
      
    $: {    
      loadEndpoints(activeColumn.columnValue, activeColumn.sortType);
      if (pageNumber != previousPageNumber) {
        previousPageNumber = pageNumber;
      }
    }  

    async function loadEndpoints(columnValue, sortTypeArg){
        if({$selectedGroup} != undefined){
            let ascending = sortTypeArg == sortType.ascending ? true : false;
            var url;
            if(columnValue == undefined){
                columnValue = 0;
            }
            if(ascending == undefined){
                ascending = true;
            }
            if(searchTerm.length > 0 && searchTerm != ""){
              if(byVessel){
                url = `/deploy/dashboard/vessels/endpoints/byvessel/${$selectedGroup}/${searchTerm.toLocaleLowerCase()}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}/${true}/${vesselId}`;
              }
              else{
                url = `/deploy/dashboard/vessels/endpoints/byvessel/${$selectedGroup}/${searchTerm.toLocaleLowerCase()}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}/${true}`;
              }                         
            }
            else{
              if(byVessel){
                url = `/deploy/dashboard/vessels/endpoints/byvessel/${$selectedGroup}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}/${true}/${vesselId}`; 
              }
              else{
                url = `/deploy/dashboard/vessels/endpoints/${$selectedGroup}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}/${true}`; 
              }                       
            }
            const res = await http.get(window.apiBaseUrl + url);
            if(res.status == 200){
                var uiEndpointCollection = await res.json();
                endpoints = uiEndpointCollection.endpoints;
                totalPageCount = uiEndpointCollection.totalPageCount;
                totalEndpointCount = uiEndpointCollection.noPaginationEndpointCount;
            }
            else if(res.status == 404){
                endpoints = [];
                totalPageCount = 0;
                totalEndpointCount = 0;
            }
        }    
   }
  
  function setPageNumber(number){
    pageNumber = number;    
  }

  async function searchEndpoints(){ 
    searchRefresh = true;    
    let interval = setInterval( async () => {
      if(searchTerm.length != inputLength){
        pageNumber = 1;
        loadEndpoints(activeColumn.columnValue, activeColumn.sortType);   
      }   
      if(!searchRefresh){
        clearInterval(interval);
      }
      inputLength = searchTerm.length;      
    }, 2000);    
  }

  async function toggleTrusted(endpoint) {
    const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/vessels/endpoint/toggletrust/${$selectedGroup}/${endpoint.id}/${!endpoint.trusted}`);

    if(res.status == 200){
      endpoint.trusted = !endpoint.trusted;
      endpoints = endpoints;
    }    
  }

  async function editComment(endpoint) {
    endpoint.editing = !endpoint.editing;

    if(!endpoint.editing && endpoint.comment.length > 0){
      const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/vessels/endpoint/comment/${$selectedGroup}/${endpoint.id}/${endpoint.comment}`);

      if(res.status == 200){
        endpoint.editing = false;        
      }    
    }
    endpoints = endpoints;    
  }

  async function getUnmanagedEndpointCSV() {
    const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/vessels/endpoints/csv/${$selectedGroup}/true`);
    if(res.status == 200){
      let data = await res.json();
      downloadByteArray("UnmanagedEndpoints.csv", data, "text/csv");
    }
  }
</script>

<Card>
    <CardHeader>
      <div class="row">
        <div class="col-sm">
            <h6 class="font-weight-bold mt-2 mb-2">Unmanaged Endpoints</h6>
        </div>
         <div class="col-sm">
            <Search id="endpoints-search-input" bind:searchTerm on:focusout={() => searchRefresh =  false} on:input={() => searchEndpoints()} placeholder="Search Endpoints..."></Search> 
         </div>
        <div class="col-sm">
          <button class="btn btn-primary float-right" on:click={() => getUnmanagedEndpointCSV()}>Export CSV</button> 
        </div>
      </div>
    </CardHeader>
    <CardBody>
      <Table responsive>
        <thead>
          <tr style="white-space: nowrap;">            
            <TableColumn on:mousedown={() => toggleSort(0, activeColumn.sortType)} active={activeColumn.columnValue == 0} sortType={activeColumn.sortType}>Host Name</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(1, activeColumn.sortType)} active={activeColumn.columnValue == 1} sortType={activeColumn.sortType}>Vessel</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(2, activeColumn.sortType)} active={activeColumn.columnValue == 2} sortType={activeColumn.sortType}>IP Address</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(3, activeColumn.sortType)} active={activeColumn.columnValue == 3} sortType={activeColumn.sortType}>MAC Address</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(4, activeColumn.sortType)} active={activeColumn.columnValue == 4} sortType={activeColumn.sortType}>Trusted</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(5, activeColumn.sortType)} active={activeColumn.columnValue == 5} sortType={activeColumn.sortType}>Comments</TableColumn> 
            <TableColumn on:mousedown={() => toggleSort(6, activeColumn.sortType)} active={activeColumn.columnValue == 6} sortType={activeColumn.sortType}>First Detected</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(7, activeColumn.sortType)} active={activeColumn.columnValue == 7} sortType={activeColumn.sortType}>Last Detected</TableColumn>  
            <TableColumn on:mousedown={() => toggleSort(8, activeColumn.sortType)} active={activeColumn.columnValue == 8} sortType={activeColumn.sortType}>Manufacturer</TableColumn> 
            <th>Actions</th>          
          </tr>          
        </thead>    
        <tbody>
          {#if endpoints.length > 0}
            {#each endpoints as endpoint}            
            <tr id="endpoint-row-{endpoint.macAddress}">                
                <td class="endpointRow">{endpoint.hostName}</td>
                <td>{endpoint.vessel}</td>
                <td>{endpoint.ipAddress}</td>
                <td>{endpoint.macAddress}</td>
                <td><Tag icon={endpoint.trusted ? "handshake" : "exclamation-triangle"} color="{endpoint.trusted  ? "success" : "warning"}" text={endpoint.trusted ? "Trusted" : "Not Trusted"}></Tag></td>
                <td>
                  <div class="d-flex">
                    <input maxlength="100" class="form-control {endpoint.editing ? "":"no-border"}" type="text" id="comment-input" bind:value={endpoint.comment} disabled={!endpoint.editing}>                               
                    <i class="{endpoint.editing ? "fas fa-save":"fas fa-edit"} mt-2"style="vertical-align:auto !important;" on:mousedown={() => editComment(endpoint)} alt="Edit Comment" title="Edit Comment"></i>
                  </div>                    
                </td>
                <td>{formatDate(endpoint.firstDetected)}</td>
                <td>{formatDate(endpoint.lastDetected)}</td>
                <td>{endpoint.manufacturer}</td>
                <td>
                  {#if !endpoint.trusted}
                    <Button id="mark-trusted" on:click={() => toggleTrusted(endpoint)} color="primary" class="btn-plus btn-icon-split btn-sm" alt="Trust" title="Trust">
                      <span class="icon text-white">
                          <i class="far fa-thumbs-up"style="vertical-align:auto !important;"></i> Trust
                      </span>
                    </Button>
                  {:else}
                    <Button id="mark-not-trusted" on:click={() => toggleTrusted(endpoint)} color="primary" class="btn-plus btn-icon-split btn-sm" alt="Revoke Trust" title="Revoke Trust">
                      <span class="icon text-white">
                          <i class=" fal fa-thumbs-down"style="vertical-align:auto !important;"></i> Revoke Trust
                      </span>
                    </Button>      
                  {/if}        
                  <Button id="forget-endpoint" on:click={() => forgetEndpointModal.show(endpoint)} color="primary" class="btn-plus btn-icon-split btn-sm" alt="Delete endpoint" title="Forget">
                    <span class="icon text-white-50">
                        <i class="fa fa-trash"style="vertical-align:auto !important;"></i>
                    </span>
                  </Button>                           
              </td>
            </tr>            
          {/each} 
          {:else}
            <tr>
              <td colspan="10" class="text-center">No endpoints to show</td>
            </tr>
          {/if}
        </tbody> 
      </Table>  
    </CardBody>
    <CardFooter>      
      <div class="pagination bg-light shadow-none ml-0 d-flex">
        <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalEndpointCount ? totalEndpointCount:pageNumber * displayNumber)} of {totalEndpointCount} endpoints</small>
        <div class="mt-2 justify-content-center">
          <Pagination>
            <PaginationItem disabled={pageNumber == 1}>
              <PaginationLink id="pagination-first-page-button" first on:click={() => pageNumber = 1} href="#"/>
            </PaginationItem>

            <PaginationItem  disabled={pageNumber == 1}>
              <PaginationLink id="pagination-previous-page-button" previous on:click={() => setPageNumber(pageNumber - 1)} href="#" />
            </PaginationItem>

            {#if totalPageCount > 5}
              {#each Array(5) as _, count}
                {#if pageNumber > 3 && pageNumber < totalPageCount - 2}
                  <PaginationItem active={pageNumber == count + pageNumber} >
                    <PaginationLink id="pagination-page-{pageNumber + count}-button" on:click={() => setPageNumber(pageNumber + count)} href="#">{pageNumber + count}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber <= 3}
                  <PaginationItem active={pageNumber == count + 1} >
                    <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber >= totalPageCount - 2}
                  <PaginationItem active={pageNumber == totalPageCount - 4 + count} >
                    <PaginationLink id="pagination-page-{totalPageCount - 4 + count}-button" on:click={() => setPageNumber(totalPageCount - 4 + count)} href="#">{totalPageCount - 4 + count}</PaginationLink>
                  </PaginationItem>
                {/if}
              {/each}
            {:else}
              {#each Array(totalPageCount) as _, count}
                <PaginationItem active={pageNumber == count + 1} on:click={() => pageNumber == count + 1}>
                  <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                </PaginationItem>
              {/each}
            {/if}      

            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-next-page-button" next href="#" on:click={() => setPageNumber(pageNumber + 1)} />
            </PaginationItem>
            
            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-last-page-button" last href="#" on:click={() => setPageNumber(totalPageCount)}/>
            </PaginationItem>
          </Pagination>
        </div>
        <div class="mt-2 ml-auto">
          <select class="form-select" id="display-number-select" bind:value={displayNumber}>
            {#each displayNumbers as displayNumber}
              <option value={displayNumber}>{displayNumber}</option>
            {/each}
          </select>
          <label class="ml-1" id="displayNumberLabel" for="display-number-select">Per page</label>     
        </div>  
      </div>
    </CardFooter>
  </Card>    

  <ForgetEndpointModal on:endpointForgotten={() => loadEndpoints(activeColumn.columnValue, activeColumn.sortType)} bind:this={forgetEndpointModal}></ForgetEndpointModal>

<style>
  .no-border{
    border-color:transparent!important;
  }

  #display-number-select{
    max-height: 30px;
    background-color: white;
    border-radius: 6px;
    border: 1px solid #DEDEDE;
    height:400px;
    color:#3a3a3a;
  }
</style>